/* eslint-disable @typescript-eslint/no-explicit-any */
// @noflow

// eslint-disable-next-line @typescript-eslint/no-use-before-define
const dixaInterval = setInterval(waitForDixa, 250)
const maxTries = 80 // twenty seconds maximum
let tries = 0

function waitForDixa() {
  const widget = document.getElementsByClassName(
    'dixa-messenger-wrapper'
  )[0] as HTMLElement
  const widgetImport = document.getElementById('dixa-widget-import')

  if (!widgetImport || !widget) return

  // Get our customization options
  const elevateMobile = widgetImport.getAttribute('elevate_mobile') === 'true'
  const elevateDesktop = widgetImport.getAttribute('elevate_desktop') === 'true'
  const widgetPosition = widgetImport.getAttribute('widget_position')

  // Limit the number of times that the waitForDixa function can be run
  if (tries >= maxTries) {
    return
  }
  // On each try, increment the number of attempts
  tries++

  if (widget) {
    // 90 as modals are 100 and we want dixa to sit under modals, but on top of everything else
    widget.style.zIndex = '90'

    // Move the widget to the desired position
    if (widgetPosition) {
      window._dixa_.invoke('setPosition', widgetPosition)
    }

    // Add the desired elevation classes
    if (elevateMobile) {
      widget.classList.add('elevate-dixa-widget--mobile')
    }

    // If we need to move the widget above a desktop footer, we add the class
    if (elevateDesktop) {
      widget.classList.add('elevate-dixa-widget--desktop')
    }

    // As the Dixa widget is now present, we can clear the setInterval
    // function safely
    clearInterval(dixaInterval)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // prettier-ignore
  (function (
    window: any,
    document: any,
    tag: any,
    url: any,
    a?: any,
    m?: any
  ) {
    if (window._dixa_) return

    window._dixa_ = {
      invoke: function (m: any, a: any) {
        window._dixa_.pendingCalls = window._dixa_.pendingCalls || []
        window._dixa_.pendingCalls.push([m, a])
      },
      addListener: function (event: any, listener: any) {
        window._dixa_.pendingAddListenerCalls =
          window._dixa_.pendingAddListenerCalls || []
        window._dixa_.pendingAddListenerCalls.push([event, listener])
      }
    }
    a = document.createElement(tag)
    m = document.getElementsByTagName(tag)[0]
    a.async = 1
    a.setAttribute('charset', 'utf-8')
    a.src = url
    m.parentNode.insertBefore(a, m)
  })(window, document,'script', 'https://messenger.dixa.io/bootstrap.js')
  const shippingCountryContentTag = document.getElementById(
    'shipping-country-for-dixa'
  )
  const shippingCountryCode = shippingCountryContentTag
    ? shippingCountryContentTag.getAttribute('data-shipping-country-code')
    : 'GB'
  const languageCode = shippingCountryContentTag
    ? shippingCountryContentTag.getAttribute('data-language-code')
    : 'en'

  if (shippingCountryCode === 'PL') {
    window._dixa_.invoke('init', {
      messengerToken: 'a0d2b7a3f8ff4bd8baf489cc9d51c798',
      language: languageCode
    })
  } else {
    window._dixa_.invoke('init', {
      messengerToken:
        process.env.NODE_ENV === 'development'
          ? '24966ff7821b4985850e65b51b2eec60'
          : '5f08a4b2470242acb8269b1a63e43501',
      language: languageCode
    })
  }
  waitForDixa()
})
